import { bindUrl, request } from "./request";
/**
 * 商品详情
 * GET /oil/product/detail
 * @param {Object} queryParams
 * @param {string} queryParams.id -
 */
export function getProductDetail(queryParams) {
  return request({
    url: bindUrl("/svc-oil/client/product/detail", {}),
    method: "GET",
    params: queryParams
  });
}

export function getProductList() {
  return request({
    url: bindUrl("/svc-oil/client/product/list", {}),
    method: "GET"
  });
}

export function getAdminProductDetail(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/admin/product/detail", {}),
    method: "POST",
    data: bodyParams
  });
}

export function getAdminProductList(queryParams) {
  return request({
    url: bindUrl("/svc-oil/admin/product/list", {}),
    method: "GET",
    params: queryParams
  });
}
